
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    icon: String,
  },
  setup(props) {
    return {
      props,
    };
  },
});
